import { type QuizQuestion } from 'components/UI/Quiz';

const data: ReadonlyArray<QuizQuestion> = [
  {
    type: 'choice',
    question:
      'Ein erster Blick in deine Vergangenheit: Bist du eher auf dem Land aufgewachsen und hast du viel Zeit draußen verbracht, oder bist du städtisch aufgewachsen und warst vielleicht eher ein Drinnie-Kind?',
    afterText:
      'Es gibt Hinweise darauf, dass bestimmte äußere Einflussfaktoren vor einer Allergieentwicklung schützen oder sie vermindern können. Das Aufwachsen in einer ländlichen Gegend oder auf einem Bauernhof stärkt das Immunsystem, da dort die Vielfalt an Allergenen sehr groß ist. In einem eher städtischen Bereich ist die Feinstaubbelastung, z.B. durch vielbefahrene Straßen höher. Dies kann das Immunsystem schwächen und somit das Allergierisiko verstärken.',
    options: [
      { text: 'Ich war viel draußen in der Natur.', points: 0 },
      { text: 'Ich war häufig zu Hause.', points: 1 },
    ],
  },
  {
    type: 'choice',
    question:
      'Hast du als Kleinkind viel Kontakt mit anderen Kindern gehabt, zum Beispiel durch Geschwister oder in der Kindertagesstätte?',
    afterText:
      'Der Kontakt mit anderen Kindern in den ersten zwei Lebensjahren stärkt das Immunsystem und kann somit das Risiko, eine Allergie zu entwickeln, senken. Denn durch das Aufeinandertreffen verschiedenster Keime und Allergene, die die Kinder mit sich bringen,  wird das Immunsystem von Anfang an trainiert.',
    options: [
      { text: 'Ja.', points: 0 },
      { text: 'Nein, erst später.', points: 1 },
    ],
  },
  {
    type: 'choice',
    question: 'Sind deine Eltern oder Geschwister auf etwas allergisch?',
    afterText:
      'Kinder, deren Eltern oder Geschwister bereits an Allergien leiden, gelten als Risikokinder. Das bedeutet, dass die Entwicklung einer Allergie erblich bedingt wahrscheinlich ist. Teilweise können Präventionsmaßnahmen das Risiko leicht abschwächen.',
    options: [
      { text: 'Ja, alle meine nahen Verwandten haben Allergien', points: 2 },
      { text: 'Ja, ein Elternteil ist allergisch auf etwas.', points: 1 },
      { text: 'Nein.', points: 0 },
    ],
  },
  {
    type: 'choice',
    question: 'Hattest du als Kind Haustiere wie Katzen, Kaninchen oder Meerschweinchen?',
    afterText:
      'Gerade bei Risikokindern wird die Anschaffung eines Felltieres nicht empfohlen. Studien weisen darauf hin, dass insbesondere Katzenhaltung einen Allergierisikofaktor für sie darstellt.  Die Tiere, die am häufigsten Tierhaarallergien auslösen, sind darüberhinaus Meerschweinchen, Ratten, Mäuse, Hamster und Kaninchen. Die Hundehaltung wird bisher nicht mit einem erhöhten Allergierisiko verbunden.',
    options: [
      { text: 'Ja.', points: 1 },
      { text: 'Nein.', points: 0 },
    ],
  },
  {
    type: 'choice',
    question: 'Bist du in einem Raucherhaushalt groß geworden?',
    afterText:
      'Tabakrauch kann vor allem das Risiko für Atemwegserkrankungen und Asthma stark erhöhen. Gerade in der Schwangerschaft sollte weder aktiv noch passiv geraucht werden, da dies das Immunsystem des Kindes stark beeinträchtigen kann und somit Allergien begünstigt werden.  Außerdem sollte generell nicht in Räumen geraucht werden, in denen sich Kinder aufhalten.',
    options: [
      { text: 'Ja.', points: 1 },
      { text: 'Nein.', points: 0 },
    ],
  },
  {
    type: 'choice',
    question:
      'Zeigen sich bei dir manchmal Allergie-Symptome wie rote, brennende Augen, juckende Haut, Husten oder ständiges Niesen?',
    options: [
      { text: 'Ja.', points: 1 },
      { text: 'Nein.', points: 0 },
    ],
  },
  {
    type: 'choice',
    question: 'Treten diese Symptome vermehrt in Frühjahr und Sommer auf?',
    afterText:
      'Pollenallergien treten hauptsächlich in der Blütezeit von Pflanzen auf, also im Frühjahr und Sommer. Um die Pollen aus dem Schlafzimmer zu verbannen, ist es sinnvoll, nur morgens und nach Regenschauern ausgiebig zu lüften und ein Pollenschutzvlies an den Fenstern anzubringen. Außerdem empfiehlt es sich für Allergiker, vor dem Schlafen die Haare zu waschen und die getragenen Kleider nicht im Schlafzimmer aufzubewahren, damit ihnen die Pollen nicht auch noch nachts zusetzen.',
    options: [
      { text: 'Ja.', points: 1 },
      { text: 'Nein.', points: 0 },
    ],
  },
  {
    type: 'choice',
    question: 'Zeigen sich vor allem nachts und frühmorgens Symptome wie Atemprobleme oder brennende Augen?',
    afterText:
      'Wenn die genannten Symptome ganzjährig auftreten, kann eine Allergie gegen Hausstaubmilben die Ursache sein. Gerade in der kalten Jahreszeit ist Hausstaub tückisch: Die Wohnung wird beheizt und genau dieses warme Klima lieben die Milben. Heizung herunter drehen, vor allem im Schlafzimmer, und regelmäßiges Stoßlüften helfen.',
    options: [
      { text: 'Ja.', points: 1 },
      { text: 'Nein.', points: 0 },
    ],
  },
  {
    type: 'choice',
    question: 'Wie reagiert dein Körper auf Insektenstiche?',
    afterText:
      'Wenn der Bereich um den Stich anschwillt und stark juckt, kann bereits eine Allergie auf Insektenstiche vorliegen und du solltest einen Allergie-Test bei einem Arzt oder einer Ärztin machen lassen. Achtung: Wenn sich allergische Symptome wie Juckreiz, Rötung und Bläschen am gesamten Körper bilden und eventuell auch das Gesicht oder der Hals anschwellen, verständige sofort den Notarzt! Denn es ist nicht ausgeschlossen, dass sich die Symptome weiter verschlimmern und lebensbedrohlich werden.',
    options: [
      {
        text: 'Leichte Rötung und leichter Juckreiz.',
        points: 0,
      },
      {
        text: 'Anschwellen der betroffenen Region und Juckreiz.',
        points: 1,
      },
      {
        text: 'Sehr starkes Anschwellen der betroffenen Region, schmerzhafte Bläschenbildung und starker Juckreiz.',
        points: 2,
      },
    ],
  },
  {
    type: 'choice',
    question:
      'Hast du nach dem Genuss von Haselnuss, Sellerie und Obst (Apfel, Erdbeere, Kiwi) festgestellt, dass du einen kratzenden Hals, eine pelzige Zunge oder gereizte Mundschleimhäute bekommst?',
    afterText:
      'Prinzipiell kann jedes eiweißhaltige Nahrungsmittel Allergien auslösen. Bei Kindern bereiten Kuhmilch, Hühnerei, Soja, Weizen und Erdnuss am häufigsten Probleme. Bei Erwachsenen sind es Haselnuss, Sellerie, Obst und Fisch. Häufig treten Nahrungsmittelallergien aber bei Menschen auf, die bereits allergisch auf Pollen sind. Denn Pollenallergene haben eine ähnliche Struktur wie Eiweißen in Lebensmitteln. Reagiert das Immunsystem auf eine Pollenart sensibel, kann es auch bei Kontakt mit strukturähnlichem Eiweiß anderer Pflanzen zu einer allergischen Reaktion kommen. Dann wird von sogenannten Kreuzallergien gesprochen.',
    options: [
      { text: 'Ja.', points: 1 },
      { text: 'Nein.', points: 0 },
    ],
  },
  {
    type: 'choice',
    question: 'Wurdest du bis zum vierten Lebensmonat (oder länger) gestillt?',
    afterText:
      'In den ersten vier Lebensmonaten bietet Muttermilch den besten Schutz gegen Allergien. Stillen ist zwar kein Garant dafür, dass das Kind allergiefrei bleibt, aber die Milch ist entscheidend für eine gesunde Darmflora des Babys. Darüber hinaus wird sein Immunsystem auf verschiedenste Nahrungsmittel vorbereitet, die in kleinsten Spuren durch die Muttermilch in den Magen des Kindes gelangen.',
    options: [
      { text: 'Ja.', points: 0 },
      { text: 'Nein.', points: 1 },
    ],
  },
];

export default data;
